// src/components/Strategy/StrategyTypes.ts

export interface StrategyData {
    name: string;
    difficulty: 'easy' | 'medium' | 'hard' | 'very hard';
    cost: 'cheap' | 'medium' | 'expensive';
    description: string;
    version?: number;
  }
  
  // Local storage key for strategies
  export const STRATEGY_STORAGE_KEY = 'savedStrategies';